<template>
    <div
            class="landing-page-header"
            :class="{
            'landing-page-buy-header': $route.name === 'property.search'
        }"
    >
        <div class="height d-none d-md-flex align-items-center justify-content-lg-center pl-3 pl-lg-0">
            <div
                    v-if="avatar && avatar.exists"
                    class="avatar-image d-flex align-items-center justify-content-center"
            >
                <div
                        :id="AVATAR_IMG_ID"
                        class="img-wrapper"
                >
                    <b-img
                            :src="avatar.publicStorageUrl"
                            class="rounded-circle"
                            width="50px"
                    />
                    <div class="after" />
                </div>
            </div>

            <b-button
                    v-for="(link, index) in links"
                    :key="index"
                    variant="custom"
                    :to="link.to"
            >
                {{ link.label }}
            </b-button>

            <div class="get-started height d-flex align-items-center justify-content-center">
                <b-link
                        class="text-decoration-none"
                        @click="btnActionCallback"
                >
                    <h4 class="text">
                        {{ actionBtnText }} <i class="fas fa-arrow-right" />
                    </h4>
                </b-link>
            </div>
        </div>
        <div class="height d-flex d-md-none align-items-center">
            <animate-hamburger
                    class="ml-auto d-block d-md-none"
            />
        </div>
    </div>
</template>

<script>
    import './LandingPageHeader.scss';
    import LandingPageAppResource from '@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource';
    import FileAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/FileAppResource";
    import StorageImage from "../../StorageImage/StorageImage";
    import {HOME_OWNERSHIP} from "@milestoneslabs/milestones-core-js/src/AppResources/LuLandingPageTypeAppResource";

    export const AVATAR_IMG_ID = 'header-avatar';
    export default {
        name: "LandingPageHeader",
        components: {StorageImage},
        props: {
            links: {
                type: Array,
                default: () => {
                }
            },
            avatar: {
                type: FileAppResource,
                default: () => new FileAppResource({}),
            },
            btnActionCallback: {
                type: Function,
                default: () => {
                },
            },
            landingPage: {
                type: LandingPageAppResource,
                required: true,
            },
        },
        data() {
            return {
                AVATAR_IMG_ID
            };
        },
        computed: {
            actionBtnText() {
                if (this.landingPage.exists && this.landingPage.typeId === HOME_OWNERSHIP) {
                    return 'Get Started';
                }

                if (this.landingPage.exists && this.landingPage.home && this.landingPage.home.actionButtonText) {
                    return this.landingPage.home.actionButtonText;
                }
                return 'Get Started';
            }
        }
    };
</script>